import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Apollo, QueryRef } from 'apollo-angular';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CartModuleConsts } from '../cart/contants';
import { StatePersistService } from '../core/services/state-persist.service';
import { getFeedbackFormDetails, getFeedbackFormDetailsPreprod } from './feedbackquery';

@Component({
    selector: 'app-feedback',
    templateUrl: './feedback.component.html',
    styleUrl: './feedback.component.scss',
    standalone: false
})
export class FeedbackComponent {
  selectedValue: string = ''; 
  feedbackConfigSubscription$!:Subscription;
  surveyUrl: any;
  selectedStore: any ;
  url: SafeHtml ='';
  FEEDBACK_QUERY = getFeedbackFormDetails()
  FEEDBACK_QUERY_PREPROD = getFeedbackFormDetailsPreprod()
  CURENT_FEEDBACK_QUERY: any;
private query: QueryRef<any>;
  constructor(private sanitizer: DomSanitizer, private statePersist: StatePersistService,
    private router: Router, private apollo: Apollo) {
  }

 

  ngOnInit(): void {
    this.selectedStore = this.statePersist.getLocalStorage('selectedStoreAddress')
    this.CURENT_FEEDBACK_QUERY = this.FEEDBACK_QUERY
    if(environment.environment == CartModuleConsts.PREPROD){
      this.CURENT_FEEDBACK_QUERY = this.FEEDBACK_QUERY_PREPROD
    }
    this.query = this.apollo.watchQuery({
      query: this.CURENT_FEEDBACK_QUERY,
      variables: {}
    });
    this.query.refetch()
    this.query.valueChanges.subscribe(result => {
      if(environment.environment == CartModuleConsts.PREPROD && result.data.wosSurveyUrlPreprods.length > 0){
        this.surveyUrl = result.data.wosSurveyUrlPreprods[0].surveyUrl
        this.url = this.surveyUrl+'?accountNumber='+this.selectedStore.selectedStoreAccountNo
        this.selectedOption(this.url)
      }
      else if(result.data.wosSurveyUrls.length > 0){
        this.surveyUrl = result.data.wosSurveyUrls[0].surveyUrl
        this.url = this.surveyUrl+'?accountNumber='+this.selectedStore.selectedStoreAccountNo
        this.selectedOption(this.url)
      }

      
    });
    
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
    
   
   
  }

  selectedOption( url : any){
    this.selectedValue =url;
    this.url =  this.sanitizer.bypassSecurityTrustResourceUrl(this.selectedValue);
  }

  datachange(){
  document.querySelector("iframe").removeAttribute('srcdoc')
  var currenturl = document.querySelector("iframe").contentWindow.location.href
  if (currenturl.includes('thank-you')){
    
    this.router.navigate(['feedback/thank-you']);

  }
  
  }

  processUrl(url) {
    if (url.indexOf('thankyou') > 0){
      console.log()
    }
    else{
      this.selectedValue = url
      this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.selectedValue)
    }
  }

  

  

  

}
